var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "product-infos"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" Your logo: ")]), _c('div', {
    staticClass: "section"
  }, [_c('v-switch', {
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:logo'),
      "label": "Display the logo banner: ".concat(_vm.enableLogo ? 'Yes' : 'No')
    },
    model: {
      value: _vm.enableLogo,
      callback: function callback($$v) {
        _vm.enableLogo = $$v;
      },
      expression: "enableLogo"
    }
  }), _vm.enableLogo ? _c('div', [_c('div', {
    staticClass: "d-flex flex-row inset"
  }, [!_vm.logo ? _c('ImageCropper', {
    attrs: {
      "input-key": "logo"
    },
    on: {
      "image-upload": _vm.onImageUpload
    }
  }) : _vm._e(), _vm.logo ? _c('div', {
    staticClass: "logo-ctn ml-3 d-flex flex-row align-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  }), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.deleteLogo
    }
  }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1) : _vm._e()], 1), _vm._m(0)]) : _vm._e()], 1), _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" Product picture: ")]), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "inset font-weight-light pt-4"
  }, [_vm._v(" The product picture will be automatically fetched from the cloud. You can go to product list to manage the name and picture for each product. ")]), _vm.isAvailable('editor:scan-result:display-mode') ? _c('div', [_c('div', {
    staticClass: "inset label font-weight-medium pt-4"
  }, [_vm._v(" Display mode ")]), _c('v-radio-group', {
    staticClass: "inset",
    attrs: {
      "column": ""
    },
    model: {
      value: _vm.productImageDisplayMode,
      callback: function callback($$v) {
        _vm.productImageDisplayMode = $$v;
      },
      expression: "productImageDisplayMode"
    }
  }, [_c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "contain",
      "label": "Contain"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v("Best suited for product image that have a white background.")]), _c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "cover",
      "label": "Cover"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v("Best suited for product image with non-white background.")]), _c('v-radio', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "value": "full-width",
      "label": "Full-width"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8"
  }, [_vm._v("This will scale your picture to the phone width increasing the overall size.")])], 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" Scan Result area: ")]), _c('div', {
    staticClass: "section"
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0 pt-4",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:text'),
      "hide-details": "",
      "label": "Customize Scan Result text: ".concat(_vm.overrideAuthMessage ? 'Yes' : 'No')
    },
    model: {
      value: _vm.overrideAuthMessage,
      callback: function callback($$v) {
        _vm.overrideAuthMessage = $$v;
      },
      expression: "overrideAuthMessage"
    }
  }), _vm.overrideAuthMessage ? _c('div', {
    staticClass: "inset"
  }, [_c('div', {
    staticClass: "table pa-3"
  }, [_vm._m(1), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Genuine")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "hide-details": "",
      "placeholder": "Enter a personalized text"
    },
    model: {
      value: _vm.authMessageOverride.genuine,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "genuine", $$v);
      },
      expression: "authMessageOverride.genuine"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Active Code")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "hide-details": "",
      "placeholder": "Enter a personalized text"
    },
    model: {
      value: _vm.authMessageOverride.active,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "active", $$v);
      },
      expression: "authMessageOverride.active"
    }
  })], 1)]), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v("Unable To Verify")]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-text-field', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "hide-details": "",
      "placeholder": "Enter a personalized text"
    },
    model: {
      value: _vm.authMessageOverride.fake,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "fake", $$v);
      },
      expression: "authMessageOverride.fake"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _c('v-switch', {
    staticClass: "ma-0 pt-4",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:branding'),
      "hide-details": "",
      "label": "Display the Scantrust brand text: ".concat(_vm.enableBranding ? 'Yes' : 'No')
    },
    model: {
      value: _vm.enableBranding,
      callback: function callback($$v) {
        _vm.enableBranding = $$v;
      },
      expression: "enableBranding"
    }
  }), _c('div', {
    staticClass: "inset font-weight-light"
  }, [_vm._v(" \"Authentication powered by Scantrust\" ")]), _c('v-switch', {
    staticClass: "ma-0 pt-4",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan-result:serial-number'),
      "hide-details": "",
      "label": "Display serial number: ".concat(_vm.showSerialNumber ? 'Yes' : 'No')
    },
    model: {
      value: _vm.showSerialNumber,
      callback: function callback($$v) {
        _vm.showSerialNumber = $$v;
      },
      expression: "showSerialNumber"
    }
  })], 1)]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "inset font-weight-light pt-4"
  }, [_vm._v(" Supported Format: PNG without background color / JPG with pure white background"), _c('br'), _vm._v(" Use square or horizontal version of your logo. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-row table-header"
  }, [_c('div', {
    staticClass: "item font-weight-medium text-caption"
  }, [_vm._v("Standard text")]), _c('div', {
    staticClass: "item font-weight-medium text-caption"
  }, [_vm._v("Personalized text")])]);

}]

export { render, staticRenderFns }